import { HTTP } from '@/modules/shared/helpers/http/facades/http'
import { Notification } from '@/modules/notification/classes/notification'
import { MessageType } from '@/modules/notification/models/types/message.type'

export function httpErrorHook(ctx) {
  HTTP.onError((e: any) => {
    if (typeof e === 'object' && e != null) {
      let message = ''
      let data = e.response.data
      if (data) {
        if (data.errors) {
          for (const [key, value] of Object.entries(data.errors)) {
            if (typeof value === 'string') {
              message = value
              Notification.show(message, MessageType.Error)
            } else if (Array.isArray(value)) {
              message = value.join(' ')
              Notification.show(message, MessageType.Error)
            } else if (typeof value === 'object') {
              for (const [key, val] of Object.entries(value)) {
                message = key + ' : ' + val
                Notification.show(message, MessageType.Error)
              }
            }
          }
        }
      } else if ('message' in e && !('message' in data)) {
        Notification.show(e.message, MessageType.Info)
      }
    }
  })
}
